// src/components/Navbar/Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  RiMenu3Fill,
  RiContactsBook2Fill,
  RiFolderInfoFill,
} from "react-icons/ri";
import { RiCloseLine } from "react-icons/ri";
import { FaHome } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";
import { MdWork } from "react-icons/md";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleDrawer = () => setIsOpen((prev) => !prev);

  const navLinks = [
    { title: "Home", link: "/", icon: <FaHome /> },
    { title: "About", link: "/about", icon: <RiFolderInfoFill /> },
    { title: "Project", link: "/project", icon: <MdWork /> },
    { title: "Contact", link: "/contact", icon: <RiContactsBook2Fill /> },
  ];

  const activeLink = ({ isActive }) => ({
    fontWeight: isActive ? 600 : 500,
    color: isActive ? "#C084FC" : "#ffffff",
    background: isActive ? "rgba(192, 132, 252, 0.1)" : "transparent",
  });

  // Show/Hide Navbar on scroll
  useEffect(() => {
    const controlNavbar = () => {
      if (window.scrollY > lastScrollY) setShow(true);
      else setShow(false);
      setLastScrollY(window.scrollY);
    };
    window.addEventListener("scroll", controlNavbar);
    return () => window.removeEventListener("scroll", controlNavbar);
  }, [lastScrollY]);

  return (

    <div
  className={`fixed w-full top-0 left-0 z-50 transition-all duration-500 backdrop-blur-lg border-b border-white/5 ${
    show
      ? "bg-[#0c0a16]/95 shadow-xl shadow-violet-500/10"
      : "bg-[#0c0a16]/90"
  }`}
>
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 sm:px-8 lg:px-16 xl:px-20 py-3 md:py-4">
        {/* Logo */}
        <Link to="/">
          <h1 className="text-2xl font-bold bg-gradient-to-r from-violet-400 to-indigo-400 bg-clip-text text-transparent font-lobster hover:from-violet-300 hover:to-indigo-300 transition-all duration-300">
            Simra.Dev
          </h1>
        </Link>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center gap-1 flex-1 justify-center max-w-2xl">
          <ul className="flex items-center gap-1">
            {navLinks.map((navItem) => (
              <li key={navItem.title}>
                <NavLink
                  to={navItem.link}
                  style={activeLink}
                  className="text-white hover:text-violet-300 transition-all duration-300 relative group px-3 py-2 rounded-lg hover:bg-violet-500/10 text-sm font-medium"
                >
                  {navItem.title}
                  <span className="absolute left-1/2 -bottom-1 w-0 h-0.5 bg-gradient-to-r from-violet-400 to-indigo-400 group-hover:w-4/5 group-hover:left-1/2 group-hover:transform group-hover:-translate-x-1/2 transition-all duration-300"></span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* Upwork Button */}
        <div className="hidden lg:flex">
          <a
            href="https://www.upwork.com/freelancers/~01a8443b236e1610ec?viewMode=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="primary-button flex items-center gap-2 bg-gradient-to-r from-violet-600 to-indigo-500 hover:from-violet-700 hover:to-indigo-600 text-white transition-all duration-300 rounded-lg px-6 py-3 shadow-lg hover:shadow-violet-500/25">
              <span>Hire on Upwork</span>
              <SiUpwork />
            </button>
          </a>
        </div>

        {/* Mobile Drawer */}
        <div className="lg:hidden">
          <button
            onClick={toggleDrawer}
            className="text-white text-2xl p-2 hover:text-violet-400 transition-colors duration-300 bg-violet-500/20 rounded-lg hover:bg-violet-500/30"
          >
            <RiMenu3Fill />
          </button>

          <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction="right"
            style={{
              background: "linear-gradient(135deg, #0c0a16 0%, #1a1533 50%, #241a40 100%)",
            }}
            className="flex flex-col justify-between p-6"
          >
            <div>
              <div className="flex justify-between items-center mb-8">
                <Link to="/" onClick={toggleDrawer}>
                  <h1 className="text-xl font-bold bg-gradient-to-r from-violet-400 to-indigo-400 bg-clip-text text-transparent">
                    Simra.Dev
                  </h1>
                </Link>
               <RiCloseLine
                   className="text-2xl text-white cursor-pointer hover:text-violet-400 transition-colors duration-300"
                   onClick={toggleDrawer}
              />
              </div>
              <ul className="flex flex-col gap-4">
                {navLinks.map((navItem) => (
                  <li key={navItem.title} onClick={toggleDrawer}>
                    <NavLink
                      to={navItem.link}
                      style={activeLink}
                      className="flex items-center gap-4 text-white hover:text-violet-300 transition-all duration-300 p-3 rounded-lg hover:bg-violet-500/10"
                    >
                      <span className="text-violet-400">{navItem.icon}</span> 
                      {navItem.title}
                    </NavLink>
                  </li>
                ))}
                <li className="mt-4">
                <a
  href="https://www.upwork.com/freelancers/~01a8443b236e1610ec?viewMode=1"
  target="_blank"
  rel="noopener noreferrer"
>
  <button className="primary-button flex items-center gap-2 bg-gradient-to-r from-violet-600 to-indigo-500 hover:from-violet-700 hover:to-indigo-600 text-white transition-all duration-300 rounded-lg px-6 py-3 shadow-lg hover:shadow-violet-500/25">
    <span>Hire on Upwork</span>
    <SiUpwork />
  </button>
</a>

                </li>
              </ul>
            </div>
            <p className="text-violet-300 text-center mt-8 text-sm">
              &copy; {new Date().getFullYear()} Simra Malik
            </p>
          </Drawer>
        </div>
      </div>
    </div>
  );
}
